import React,{ Component } from 'react';
import PropTypes from 'prop-types';

import { connect } from "react-redux";
import * as galleryReducers from "../../reducers/gallery";
import * as galleryActions from "../../actions/gallery";
import {withRouter} from 'react-router';
import { Input} from 'reactstrap';

import * as vignetsActions from "../../actions/vignets";
import * as playlistActions from "../../actions/playlist";
import * as vignetsReducers from "../../reducers/vignets";
import * as playlistReducers from "../../reducers/playlist";
import * as userReducers from "../../reducers/user";
import * as userActions from "../../actions/user";

class FilterBar extends Component {

    constructor(props) {
        super(props);
        this.state = {
            search_text: '',
            userDet : JSON.parse(window.localStorage.userDet),
            sortText :'Newest'
        };
        this.search = this.search.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    componentDidMount() {
        if(this.props.pageName === 'VIGNETS') {

        }
        else if(this.props.pageName === 'MY_UPLOADS') {
            /* let data = {"type" : pageType, userid : JSON.parse(window.localStorage.userDet).user_id};
             total = props.getTotalCount(data);
             if(total) {
                 itemsCount = total.itemsCount;
             }*/

        }
        else if(this.props.pageName === 'AUDIO') {
        }
        else if(this.props.pageName === 'VIDEO') {
        }
    }

    handleInputChange(event) {
        this.setState({
            [event.target.name]: event.target.value
        });
    }

    search(sortType) {

        if(sortType) {
            let sortText = 'Newest';
            switch (sortType) {
                case 'new' : sortText = 'Newest';
                            break;
                case 'old' : sortText = 'Oldest';
                    break;
                case 'az' : sortText = '[A-Z]';
                    break;
                case 'za' : sortText = '[Z-A]';
                    break;
                default :sortText = 'Newest';
                    break;
            }

            this.setState({sortText:sortText, sortType:sortType})
        }
        console.log(this.props.pageName);


        if(this.props.pageName === 'VIGNETS') {
            let data = {'vignetsList' : this.props.vignetsData.vignetsList, 'search_text' : this.state.search_text, userid: this.state.userDet.user_id, 'sort' : sortType?sortType:'new'};
            this.props.searchVignets(data);
        }
        else if(this.props.pageName === 'MY_UPLOADS' || this.props.pageName === 'AUDIO' || this.props.pageName === 'VIDEO') {
            let data = {'vignetsList' : this.props.vignetsData.vignetsList, 'search_text' : this.state.search_text, userid: this.state.userDet.user_id, 'sort' : sortType?sortType:'new'};
            data.gal_type = this.props.pageName;
            this.props.searchGallery(data);
        }
        else if(this.props.pageName === 'PLAYLIST') {
            let data = {'playlistData' : this.props.playlistData.playListItems, 'search_text' : this.state.search_text, userid: this.state.userDet.user_id, 'sort' : sortType?sortType:'new'};
            console.log("searchPlaylist");
            this.props.searchPlaylists(data);
        }
        else if(this.props.pageName === 'USER') {
            let data = {'userListData' : this.props.userListData.userList, 'search_text' : this.state.search_text, userid: this.state.userDet.user_id, 'sort' : sortType?sortType:'new'};
            console.log("searchUser");
            this.props.searchUser(data);
        }
    }

    render() {

        return (

            <div className="filter-block">
                <div className="filter-block-wrap">

                    <div className="sort-wraper">
                        <div className="dropdown custom-dropdown">
                            <label>Sort by: </label>
                            <button className="custom-drop dropdown-toggle" type="button"
                                    id="dropdownMenu2" data-toggle="dropdown" aria-haspopup="true"
                                    aria-expanded="false">{this.state.sortText}
                            </button>
                            <div className="dropdown-menu" aria-labelledby="dropdownMenu2"
                                 x-placement="bottom-start"
                                 style={{
                                     position: 'absolute',
                                     transform: 'translate3d(46px, 34px, 0px)',
                                     top: '0px',
                                     left: '0px',
                                     'willChange': 'transform'
                                 }}>
                                <button className="dropdown-item" type="button" onClick={(e) => this.search('new')}>Newest</button>
                                <button className="dropdown-item" type="button" onClick={(e) => this.search('old')}>Oldest</button>

                                {this.props.pageName !== 'MY_UPLOADS' && this.props.pageName !== 'AUDIO' && this.props.pageName !== 'VIDEO' &&
                                <button className="dropdown-item" type="button"
                                        onClick={(e) => this.search('az')}>[A-Z]</button>
                                }
                                {this.props.pageName !== 'MY_UPLOADS' && this.props.pageName !== 'AUDIO' && this.props.pageName !== 'VIDEO' &&
                                <button className="dropdown-item" type="button" onClick={(e) => this.search('za')}>[Z-A]</button>
                                }

                            </div>
                        </div>
                        {this.props.pageName !== 'MY_UPLOADS' && this.props.pageName !== 'AUDIO' && this.props.pageName !== 'VIDEO' &&
                        <div className="search-block">
                            <Input type="text" name="search_text" className="search-box" placeholder="Search"
                                   onChange={this.handleInputChange} onKeyUp={(e) => this.search(this.state.sortType)}/>
                            <button className="search-btn icon-lib search-ico" onClick={(e) => this.search(this.state.sortType)}></button>
                        </div>
                        }
                    </div>

                </div>
            </div>

        );
    }
}



FilterBar.propTypes = {
    pageName: PropTypes.string
}


function mapStateToProps(state) {
    return {
        //totalCount  :galleryReducers.getGalleryData(state),
        itemType  :galleryReducers.setGalleryUpdate( state),
        vignetsData  :vignetsReducers.getVignetsData(state),
        playlistData  :playlistReducers.getPlaylistData(state),
        userListData  :userReducers.getUserData(state)
    };

}
export default  withRouter(connect(mapStateToProps, {
   // getTotalCount : galleryActions.galleryCount,
    getGalleryStatus : galleryActions.getType,
    searchVignets : vignetsActions.searchVignets,
    searchPlaylists : playlistActions.searchPlaylists,
    searchGallery : galleryActions.searchGallery,
    searchUser    : userActions.searchUser
})(FilterBar));





// WEBPACK FOOTER //
// ./src/components/common/FilterBar.js